module.exports = __webpack_public_path__ + "img/shield_done.6a74572a.svg";